import { ModelError_Response } from '@treadinc/horizon-api-spec';
import { isAxiosError } from 'axios';

import {
  INFINITE_QUERY_PAGINATION_LIMIT,
  InfiniteQueryBaseParams,
  InfiniteQueryParamsState,
} from './constants';

export const readFirstError = (error: unknown) =>
  isAxiosError<ModelError_Response>(error)
    ? error.response?.data?.error?.errors?.[0]
    : undefined;

export function deriveInfiniteQueryBaseParams(queryParams: InfiniteQueryParamsState) {
  const { filters, pagination } = queryParams;

  const query: InfiniteQueryBaseParams = {
    'page[limit]': INFINITE_QUERY_PAGINATION_LIMIT,
  };

  if (pagination?.after) {
    query['page[after]'] = pagination.after;
  }

  if (filters.query.trim().length) {
    query['search[query]'] = filters.query.trim();
  }

  return query;
}
